import { useIsDisabled } from './helpers.js'
import View from './view.js'
import React from 'react'

export default function Logic(props) {
  let disabled = useIsDisabled(props)

  return <View viewPath={props.viewPath} disabled={disabled} />
}
